import type { ParamsSerializerOptions } from 'axios';

import type { GetDataSeriesForTargetParams } from '@/generated/model';

export function serializeDataSeriesParams(params: GetDataSeriesForTargetParams): string {
  const searchParams = new URLSearchParams();

  // The endpoint requires the parameter to be present, so an empty selection sends an empty value.
  if (params.measureChannelIds.length === 0) {
    searchParams.append('measureChannelIds', '');
  } else {
    params.measureChannelIds.forEach((channelId) => searchParams.append('measureChannelIds', String(channelId)));
  }

  searchParams.append('fromTimeMicros', String(params.fromTimeMicros));
  searchParams.append('toTimeMicros', String(params.toTimeMicros));

  return searchParams.toString();
}

export const dataSeriesParamsSerializer: ParamsSerializerOptions = {
  serialize: (params) => serializeDataSeriesParams(params as GetDataSeriesForTargetParams),
};
